<template>
    <div class="pagosTable mt-5" style="width: 100%;">
        <vs-row>
            <vs-col loading vs-type="flex" vs-justify="center" vs-align="center" w="3" lg="3" sm="12" xs="12">
                <vs-card class="separated vs-card-no-width">
                    <template #title> 
                        <h3>{{sumaPagos | currency}}</h3>
                    </template>
                    <template #text>
                            <small>
                                Total de pagos aplicados
                            </small>
                            <hr class="line-color" style="background-color:#61ce63" >
                        <div v-if="dataEstadisticosGral.length > 1">
                            <div v-for="(info, i) in dataEstadisticosGral" :key="i">
                                {{info.nombre}}
                                <strong v-if="info.pagos">{{info.pagos | currency}} </strong>
                                <hr>
                            </div>
                        </div>
                    </template>
                </vs-card>
            </vs-col>

            <vs-col loading vs-type="flex" vs-justify="center" vs-align="center" w="3" lg="3" sm="12" xs="12">
                <vs-card class="separated vs-card-no-width">
                    <template #title>
                        <h3>{{sumaCargos | currency}}</h3>
                    </template>

                    <template #text>
                            <small>
                                Cargos por cobrar en tiempo
                            </small>
                            <hr class="line-color" style="background-color:#febb34" >
                        <div v-if="dataEstadisticosGral.length > 1">
                            <div v-for="(info, i) in dataEstadisticosGral" :key="i">
                                {{info.nombre}}
                                <strong v-if="info.cargos_en_tiempo">{{info.cargos_en_tiempo | currency}} </strong>
                                <hr>
                            </div>
                        </div>
                    </template>
                </vs-card>
            </vs-col>

            <vs-col loading vs-type="flex" vs-justify="center" vs-align="center" w="3" lg="3" sm="12" xs="12">
                <vs-card class="separated vs-card-no-width">
                    <template #title>
                        <h3>{{sumaCartera | currency}}</h3>
                    </template>

                    <template #text>
                            <small>
                                Cartera vencida
                            </small>
                            <hr class="line-color" style="background-color:#f24952" >
                        <div v-if="dataEstadisticosGral.length > 1">
                            <div v-for="(info, i) in dataEstadisticosGral" :key="i">
                                {{info.nombre}}
                                <strong v-if="info.cartera_vencida">{{info.cartera_vencida | currency}} </strong>
                                <hr>
                            </div>
                        </div>
                    </template>
                </vs-card>
            </vs-col>

            <vs-col loading vs-type="flex" vs-justify="center" vs-align="center" w="3" lg="3" sm="12" xs="12">
                <vs-card class="separated vs-card-no-width">
                    <template #title>
                        <h3>{{sumaDescuentos | currency}}</h3>
                    </template>

                    <template #text>
                            <small>
                                Total de descuentos aplicados (Becas y promociones)
                            </small>
                            <hr class="line-color" style="background-color:#292b2c" >
                        <div v-if="dataEstadisticosGral.length > 1">
                            <div v-for="(info, i) in dataEstadisticosGral" :key="i">
                                {{info.nombre}}
                                <strong v-if="info.descuentos_aplicados">{{info.descuentos_aplicados | currency}} </strong>
                                <hr>
                            </div>
                        </div>
                    </template>
                </vs-card>
            </vs-col>
        </vs-row>
    </div>
</template>


<script>
import { elementAt } from 'rxjs/operators'
import cobranza from '../../../api/requests/cobranza-persona'
import cardGeneral from './cards-estadisticos.vue'

export default {
    props:[
        'personaid'
    ],
    data () {
        return {
            dataEstadisticosGral : [],
            persona: [{
                "id": "479",
            },{
                "id": "559",
            }],
            sumaPagos: 0,
            sumaCargos: 0,
            sumaCartera: 0,
            sumaDescuentos: 0
        }
    },
    components:{
        cardGeneral
    },
    created(){
        this.getEstadisticosGrales()
    },
    methods : {
        async getEstadisticosGrales () {
                try {
                    for (const element of this.personaid) {
                        const response = await cobranza.getDataGeneralPersona(element)
                        this.dataEstadisticosGral.push(response.data)
                    }
                    this.getSumaPagos()
                    this.getSumaCargos()
                    this.getSumaCartera()
                    this.getsumaDescuentos()
                } catch (error) {

                }
        },
        getSumaPagos(){
            this.dataEstadisticosGral.forEach(element => {
                if(element.pagos){
                    this.sumaPagos += parseFloat(element.pagos)
                }
            })
        },
        getSumaCargos(){
            this.dataEstadisticosGral.forEach(element => {
                if(element.cargos_en_tiempo){
                    this.sumaCargos += parseFloat(element.cargos_en_tiempo)
                }
            })
        },
        getSumaCartera(){
            this.dataEstadisticosGral.forEach(element => {
                if(element.cartera_vencida){
                    this.sumaCartera += parseFloat(element.cartera_vencida)
                }
            })
        },
        getsumaDescuentos(){
            this.dataEstadisticosGral.forEach(element => {
                if(element.descuentos_aplicados){
                    this.sumaDescuentos += parseFloat(element.descuentos_aplicados)
                }
            })
        }
    },
}
</script>
<style lang="scss"  scoped >
.line-color {
    margin-bottom:0.2em;
    width:100%;
    text-align:left;
    margin-left:0;
    height:5px
}
</style>

